module.exports = __webpack_public_path__ + "static/navyknitbear-dd18070589f3a0b97d9923ddb60a89b1.jpeg";